import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { environment } from '@environments/environment';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { Employee } from '@app/_models/_DTOs/employee';
import { EmployeeService } from '@app/_services/employee.service';
import { ITuple } from '@app/_models/tuple';
import { Observable, Subscription } from 'rxjs';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetHistory, AssetHistoryActionName } from '@app/_models/_DTOs/assetHistory';
import { AssetService, AuthenticationService } from '@app/_services';
import { DocumentService } from '@app/_services/document.service';
import { NzMessageService } from 'ng-zorro-antd';
import { AssetType } from '@app/_models/enums/assetType';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { ResizeService } from '@app/_services/resize.service';
import { AssetDetailsComponent } from '@app/assets/asset-details/asset-details.component';
import { AssetListComponent } from '@app/assets/asset-list/asset-list.component';
import { Location } from '@app/_models/_DTOs/location';
import { LocationService } from '@app/_services/location.service';
import { BaseComponent } from '@app/_shared/base.component';
import { UserToken } from '@app/_models';

@Component({
  selector: "app-employee-details",
  templateUrl: "./employee-details.component.html",
  styleUrls: ["./employee-details.component.css"],
})
export class EmployeeDetailsComponent extends BaseComponent implements OnInit {
  onScreenResize(screenSize: SCREEN_SIZE) {}
  onUserAvailable(userToken: UserToken) {}
  @ViewChild(AssetDetailsComponent, { static: false })
  private assetDetailsComponent: AssetDetailsComponent;

  @Input() selectedEmployee: Employee;
  @Input() level: number;

  selectedLocation: Location;

  @Output() drawerClosed = new EventEmitter();

  drawerWidth: string;
  order: string = "-logTime";

  assetsPageIndex = 1;
  assetsPageSize = 10;
  assetsTotal = 1;
  employeeAssetList: Asset[] = [];
  loadingAssets = true;

  @ViewChild(AssetListComponent, { static: false })
  private assetListComponent: AssetListComponent;

  isAllDisplayDataChecked = false;
  isOperating = false;
  isIndeterminate = false;
  mapOfCheckedId: { [key: string]: boolean } = {};
  numberOfChecked = 0;

  apiUrl: string;

  public assetHistoryActionType = AssetHistoryActionType;
  public assetTypes = AssetType;

  constructor(
    private employeeService: EmployeeService,
    private assetService: AssetService,
    private locationService: LocationService,
    private documentService: DocumentService,
    private messageService: NzMessageService,
    protected authenticationService: AuthenticationService,
    protected resizeService: ResizeService
  ) {
    super(authenticationService, resizeService);
    this.apiUrl = environment.apiUrl;

    this.resizeService.onResize$.subscribe((size) => {
      this.drawerWidth = this.resizeService.getWideDrawerWidth();
    });
  }

  ngOnInit() {
    // if (this.selectedEmployee) {
    //   this.searchEmployeeAssets(this.selectedEmployee.id, true);
    // }

    if (this.resizeService.currentSize != null) {
      this.drawerWidth = this.resizeService.getWideDrawerWidth();
    }
  }

  ngOnDestroy() {}

  closeDetails() {
    this.closeAssetDetails();
    this.employeeAssetList = [];
    this.selectedEmployee = null;
    this.drawerClosed.emit();
  }

  openAssetDetailsFromId(assetId: number) {
    this.assetService.get(assetId).subscribe((data: Asset) => {
      this.assetDetailsComponent.loadAsset(data.id);
    });
  }

  closeAssetDetails() {
    this.assetListComponent.closeAssetDetails();
  }

  openLocationDetails(location: Location) {
    this.locationService.get(location.id).subscribe((data: Location) => {
      this.selectedLocation = data;
    });
  }

  closeLocationDetails() {
    this.selectedLocation = null;
  }

  getHistory() {
    var history: AssetHistory[] = [];
    if (this.selectedEmployee) {
      if (this.selectedEmployee.assignedAssets) {
        history.push(...this.selectedEmployee.assignedAssets);
      }
      if (this.selectedEmployee.unassignedAssets) {
        history.push(...this.selectedEmployee.unassignedAssets);
      }
    }
    return history
      .sort((a, b) => {
        var logTimeA = new Date(a.logTime).getTime();
        var logTimeB = new Date(b.logTime).getTime();
        if (logTimeA > logTimeB) return -1;
        if (logTimeA < logTimeB) return 1;
        return 0;
      })
      .filter((x) => x.asset.deleted != 1);
  }

  getPdf(assetHistoryAction: AssetHistory) {
    var document = assetHistoryAction.documents.sort((val1, val2) => {
      return (
        new Date(val2.created).getTime() - new Date(val1.created).getTime()
      );
    })[0];
    this.documentService.getPdf(document.id).subscribe((result: any) => {
      if (result.type == "application/pdf") {
        var blob = new Blob([result], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var fileUrl = URL.createObjectURL(blob);
          window.open(fileUrl, "_blank");
        }
      } else {
        this.messageService.create("error", "Dokument nije pronađen.");
      }
    });
  }

  private getActionTypeName(actionType: AssetHistoryActionType) {
    return AssetHistoryActionName.get(actionType).name;
  }

  private getAssetTypeName(assetType: AssetType) {
    return AssetTypeName.get(assetType);
  }

  private assetTypeKeys() {
    var keys = Object.keys(this.assetTypes);
    return keys.slice(keys.length / 2);
  }
}
